import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const Building07Icon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon {...props} viewBox="0 0 22 20">
    <path
      d="M6.25 8.75H3.35C2.78995 8.75 2.50992 8.75 2.29601 8.85899C2.10785 8.95487 1.95487 9.10785 1.85899 9.29601C1.75 9.50992 1.75 9.78995 1.75 10.35V18.75M15.25 8.75H18.15C18.7101 8.75 18.9901 8.75 19.204 8.85899C19.3922 8.95487 19.5451 9.10785 19.641 9.29601C19.75 9.50992 19.75 9.78995 19.75 10.35V18.75M15.25 18.75V3.95C15.25 2.8299 15.25 2.26984 15.032 1.84202C14.8403 1.46569 14.5343 1.15973 14.158 0.967987C13.7302 0.75 13.1701 0.75 12.05 0.75H9.45C8.32989 0.75 7.76984 0.75 7.34202 0.967987C6.96569 1.15973 6.65973 1.46569 6.46799 1.84202C6.25 2.26984 6.25 2.8299 6.25 3.95V18.75M20.75 18.75H0.75M9.75 4.75H11.75M9.75 8.75H11.75M9.75 12.75H11.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);
